import { Alert, Box, Text } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';

export const messages = defineMessages({
  couponsErrorText: {
    defaultMessage:
      'Sorry, we’re having trouble looking these up. If you have a code, enter it above, or try checking for coupons later.',
  },
});

export const CouponsError = () => {
  const intl = useIntl();
  return (
    <Box marginTop="s" paddingTop="m">
      <Alert intent="error">
        <Text type="body2">
          {intl.formatMessage(messages.couponsErrorText)}
        </Text>
      </Alert>
    </Box>
  );
};
